import { includes, map, startsWith } from 'lodash';

let isClicked = false;
let currentMenu = 'Accounts';

const config = {
  mobileView: 3,
  tabletView: 4,
  desktopView: 5,
};

/*
  IMPORTANT:-
  Documenting what each attribute mean:-
  {
    id: 'Unique id for each menu item used for identifying action and checks',
    title: 'Menu label for display either in main nav or more dropdown list',
    // Prioritize where menu will live if webapp is rendered on different device
    // P1 will always be at top header where as P3 will always be in more menu dropdown, P2 will float based on space and device size
    priority: 'P1|P2|P3',
    subHeading: true, // true means this menu act as a label and has sub menus attached
    className: 'c-site-nav__icon', // Set icon class and apply special css class if needed
    navAction: 'Define which route navigation app will go next',
    bank: ['CB', 'YB', 'DYB', 'VM'], // check if menu should be displayed for specific brand
  }
*/

const menuItemObjList = [
  {
    id: 'mymessage',
    title: 'Messages and documents',
    priority: 'P3',
    subHeading: true,
    navAction: '',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'mydetails',
    title: 'Your details',
    priority: 'P3',
    subHeading: true,
    className: 'c-site-nav__icon',
    navAction: '',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'managecreds',
    title: 'Login, access and security',
    priority: 'P3',
    subHeading: true,
    className: 'c-site-nav__icon',
    navAction: '',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'accounts',
    title: 'Accounts',
    priority: 'P1',
    navAction: 'WEB-HOMEPAGE',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'movemoney',
    title: 'Move money',
    priority: 'P1',
    navAction: 'WEB-OPEN-MOVEMONEY',
    bank: ['CB', 'DYB', 'YB', 'VM'],
  },
  {
    id: 'movemoney-bib',
    title: 'Payments',
    priority: 'P1',
    navAction: 'WEB-OPEN-MOVEMONEY',
    bank: ['CB', 'DYB', 'YB', 'VM'],
  },
  {
    id: 'spending',
    title: 'Spending',
    priority: 'P1',
    navAction: 'WEB-OPEN-SPENDINGS',
    bank: ['DYB', 'VM'],
  },
  {
    id: 'products',
    title: 'Products',
    priority: 'P2',
    navAction: 'WEB-PRODUCT-INFO',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'marketplace',
    title: 'Marketplace',
    priority: 'P2',
    navAction: '',
    bank: ['VM'],
  },
  {
    id: 'help',
    title: 'Help',
    priority: 'P2',
    navAction: 'WEB-OPEN-HELP',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'usermanagement',
    title: 'User management',
    priority: 'P3',
    subHeading: true,
    className: 'c-site-nav__icon',
    navAction: '',
    bank: ['CB', 'YB', 'VM'],
  },
  {
    id: 'accountservices',
    title: 'Account services',
    priority: 'P3',
    subHeading: true,
    className: 'c-site-nav__icon',
    navAction: '',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'accountprefs',
    title: 'Account preferences',
    priority: 'P3',
    subHeading: true,
    navAction: '',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
  {
    id: 'tools',
    title: 'Tools',
    priority: 'P3',
    subHeading: true,
    navAction: '',
    bank: ['CB', 'YB', 'VM'],
  },
  {
    id: 'logout',
    title: 'Log out',
    priority: 'P3',
    subHeading: false,
    navAction: 'WEB-AUTHENTICATION',
    bank: ['CB', 'YB', 'DYB', 'VM'],
  },
];
const getMyDetails = (exclusionList) =>
  [
    {
      id: 'personalContactDetails',
      title: 'Change your contact details',
      className: 'icon-helps',
      navAction: 'WEB-MANAGE-PERSONAL-DETAILS',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'contactPreferences',
      title: 'Contact preferences',
      className: 'icon-helps',
      navAction: 'WEB-CONTACT-PREFERENCES',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'marketingPreference',
      title: 'Marketing preferences',
      className: 'icon-helps',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
  ].filter((item) => !includes(exclusionList, item.id));

const accountservices = [
  {
    id: 'manageDebitCards',
    title: 'Manage debit cards',
    className: 'icon-helps',
    navAction: 'WEB-MANAGE-CARD',
    conditions: {
      bank: ['CB', 'YB', 'VM'],
    },
  },
  {
    id: 'companylimits',
    title: 'View company limits',
    className: 'icon-helps',
    navAction: 'WEB-USER-MANAGEMENT',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'balanceexport',
    title: 'Download balances',
    className: 'icon-helps',
    navAction: '',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'manageCard',
    title: 'Manage your cards',
    className: 'icon-helps',
    navAction: 'WEB-MANAGE-CARD',
    conditions: {
      bank: ['CB', 'YB', 'VM'],
    },
  },
  {
    id: 'manageaccountpools',
    title: 'Manage account pools',
    className: 'icon-helps',
    navAction: 'WEB-ACCOUNT-POOLS',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'closeAccount',
    title: 'Close an account',
    className: 'icon-helps',
    navAction: '',
    conditions: {
      bank: ['CB', 'YB', 'VM'],
    },
  },
];
const accountPrefs = [
  {
    id: 'renameaccount',
    title: 'Rename accounts',
    className: 'icon-helps',
    navAction: 'WEB-RENAME-ACCOUNT',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'stmtprefs',
    title: 'Statement preferences',
    className: 'icon-helps',
    navAction: 'WEB-STATEMENTS-PREFERENCES',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'paperfree',
    title: 'Paper-free preferences',
    isMobileView: false,
    isTabletView: false,
    isDesktopView: false,
    className: 'c-site-nav__icon icon icon-helps',
    navAction: 'WEB-STATEMENTS-PREFERENCES',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'alerts',
    title: 'Manage your alerts',
    className: 'icon-helps',
    navAction: 'WEB-OPEN-ALERTS',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'accountorder',
    title: 'Change account order',
    className: 'icon-helps',
    navAction: 'WEB-ACCOUNT-PREFERENCES',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
];
const managecreds = (exclusionList) =>
  [
    {
      id: 'managecredentials',
      title: 'Manage login and security details',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'lastLogin',
      title: 'Previous login',
      navAction: 'WEB-LAST-LOGIN',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'activateYourSecurityToken',
      title: 'Activate security token',
      className: 'icon-helps',
      navAction: 'WEB-ACTIVATE-YOUR-SECURITY-TOKEN',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'manageMobileDevice',
      title: 'Mobile app access',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['CB', 'YB', 'DYB', 'VM'],
      },
    },
    {
      id: 'consentManageB',
      title: 'Connected to B',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['DYB'],
      },
    },
    {
      id: 'consentManageVM',
      title: 'Open banking connections',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['VM'],
      },
    },
    {
      id: 'consentManage',
      title: 'Third party permissions',
      navAction: 'NAVIGATE-TO-WEBAPPS',
      conditions: {
        bank: ['CB', 'YB'],
      },
    },
  ].filter((item) => !includes(exclusionList, item.id));

const mymessage = [
  {
    id: 'securemessage',
    title: 'Secure messages',
    navAction: 'WEB-SECURE-MESSAGE',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
  {
    id: 'my-documents',
    title: 'Your letters and documents',
    navAction: 'WEB-DOCUMENT-LIBRARY',
    conditions: {
      bank: ['CB', 'YB', 'DYB', 'VM'],
    },
  },
];

const userManagement = [
  {
    id: 'useraccess',
    title: 'Manage user access',
    className: 'icon-helps',
    navAction: 'WEB-USER-MANAGEMENT',
    conditions: {
      bank: ['CB', 'YB', 'VM'],
    },
  },
];

const toolsSection = [
  {
    id: 'overdraftCostCalculator',
    title: 'Overdraft Cost Calculator',
    className: 'icon-helps',
    navAction: '',
    conditions: {
      bank: ['CB', 'YB', 'VM'],
    },
  },
];

class SiteHeader {
  static getMenuItems(bankId) {
    const menuItems = [];
    map(menuItemObjList, (item) => {
      if (includes(item.bank, bankId.toUpperCase())) {
        menuItems.push(item);
      }
    });
    return menuItems;
  }

  static getSubHeadings(id, exclusionList = []) {
    switch (id) {
      case 'accountprefs':
        return accountPrefs;
      case 'mymessage':
        return mymessage;
      case 'managecreds':
        return managecreds(exclusionList);
      case 'accountservices':
        return accountservices;
      case 'mydetails':
        return getMyDetails(exclusionList);
      case 'usermanagement':
        return userManagement;
      case 'tools':
        return toolsSection;
      default:
        return [];
    }
  }

  static getLength(device) {
    switch (device) {
      case 'mobile':
        return config.mobileView;
      case 'tablet':
        return config.tabletView;
      case 'desktop':
        return config.desktopView;
      default:
        return 0;
    }
  }

  static getNonAccessibleModules() {
    return [
      'WEB-ACCOUNT-PREFERENCES',
      'WEB-STATEMENTS-PREFERENCES',
      'WEB-OPEN-SPENDINGS',
      'WEB-OPEN-SAVING-POTS',
      'WEB-PROJECTIONS',
      'WEB-DIGITAL-STATEMENTS',
      'WEB-OPEN-FINANCIAL_STORIES',
    ];
  }

  static getAdaptiveModules() {
    return [
      'WEB-PROJECTIONS',
      'WEB-DIGITAL-STATEMENTS',
      'WEB-OPEN-FINANCIAL_STORIES',
    ];
  }

  static menuClicked() {
    isClicked = true;
  }

  static isMenuClicked() {
    if (isClicked) {
      isClicked = false;
      return true;
    } else {
      return isClicked;
    }
  }
  static updateCurrentMenu(newMenu) {
    if (startsWith(newMenu, 'WEB-')) {
      const cur = menuItemObjList.filter((item) => {
        return item.navAction.indexOf(newMenu) !== -1;
      });
      if (cur.length === 1) {
        currentMenu = cur[0].title;
      }
    } else {
      currentMenu = newMenu;
    }
  }
  static getCurrentMenu() {
    return currentMenu;
  }
}

export default SiteHeader;
